import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";
import { HumanFilter } from "@/services";

export class SalesNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		console.log(this.Data);
		if (!Array.isArray(this.Data.SaleIDs)) return {};
		if (this.Data.SaleIDs.length == 0) return {};
		if (this.Data.SaleIDs.length == 1) {
			return {
				routeTo: `/sales/info/${this.Data.SaleIDs[0]}`
			};
		}
		let filters = [
			new HumanFilter({Field: "this.ID", Operator: "in", Values: this.Data.SaleIDs.map((s:any)=>`${s}`)})
		] as HumanFilter[];
		let filterParam = {
			filters: filters.map(f=>f.getJSON())
		};
		return {
			routeTo: `/sales?filters=${JSON.stringify(filterParam)}`
		};
	}

	public getIcon():string {
		return "file-invoice";
	}

	public getActionKey():string {
		if (!Array.isArray(this.Data.SaleIDs) || this.Data.SaleIDs.length == 0) return "";
		return this.Data.SaleIDs.length == 1 ? "open-document" : "open-documents";
	}
}
